import React, { useState, useRef } from "react";
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import ModalPopup from 'components/modal/';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import DateUtil from "utils/DateUtil";
import CommonUtil from 'utils/CommonUtil';
import UISelect from 'components/selectbox/UISelect';
import UIUtils from "utils/UIUtils";
import { Link } from 'react-router-dom';
function ContentsContainer() {	
	const [FDS_CFG_YN, setFDS_CFG_YN] = useState('N');
	const [REG_YYYY, setREG_YYYY] = useState('');
	const [PAY_REQ_NO, setPAY_REQ_NO] = useState('');
	const [totalRowCnt,setTotalRowCnt] = useState(0);	
	const [showRowCnt,setShowRowCnt] = useState(20); //기본 row count
	const [FDS_START_HH, setFDS_START_HH] = useState('');
	const [FDS_START_MI, setFDS_START_MI] = useState('');
	const [FDS_END_HH, setFDS_END_HH] = useState('');
	const [FDS_END_MI, setFDS_END_MI] = useState('');
	const [modalIsOpen, setModalIsOpen] = useState(false);
	
    let SheetData = {};
    let totalCnt = useRef<number>(0);
	let defaultRowCnt = 20;
	let rowCnt = useRef<number>(20);

	var ib = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				/*
	            "SearchMode": 0,
	            "SectionCanResize": 1,
	            "CanSort": false,
	            "CanColMove": false,
	            "CanColResize": false,
	            "HeaderCheck": 0,
	            "CanEdit": 0,
	            "Hover": 0,
	            "Height": 500,
	            "PageLength": 20,
	            "InfoRowConfig": {
	            },
	            */   
				"SearchMode": 1,
				"PageLength": defaultRowCnt,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "auto",	   
				         		
			},
			/*
			"Def": {
			    "Row": {
			    	"CanFormula": 1,
					"CalcOrder": "LAST_STATUS_DISPTextColor",
		    	},
    		},	
    		*/		
				//틀고정 좌측 컬럼 설정
			"Cols": [
	            {"Header": "NO",		"Type": "Int",	"Name": "SEQ",				"RelWidth": 1,		"Align": "Center",	"CanEdit": 0},
	            {"Header": "지급신청번호",	"Type": "Text",	"Name": "PAY_REQ_NO_DISP",	"RelWidth": 1.5,	"Align": "Center",	"CanEdit": 0},
	            {"Header": "집행일시",		"Type": "Text",	"Name": "TRAN_DATETIME",	"RelWidth": 1.5,	"Align": "Center",	"CanEdit": 0},
	            {"Header": "은행명",		"Type": "Text",	"Name": "BANK_NM",			"RelWidth": 1,		"Align": "Center",	"CanEdit": 0},
	            {"Header": "입금계좌번호",	"Type": "Text",	"Name": "ACCT_NO_DISP",		"RelWidth": 2, 		"Align": "left",	"CanEdit": 0},
	            {"Header": "출금금액",		"Type": "Text",	"Name": "TRAN_AMT",			"RelWidth": 2,		"Align": "Right",	"CanEdit": 0},
	            {"Header": "적요",		"Type": "Text",	"Name": "OUT_RMK",			"RelWidth": 2,		"Align": "left",	"CanEdit": 0},
	            {"Header": "담당자",		"Type": "Text",	"Name": "PERSON_NM",		"RelWidth": 1.5,	"Align": "Center",	"CanEdit": 0},
	            
            ],
       
		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				onClickSearch();
				
			},
			
			onAfterGotoPage:function (evtParam) {
				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
		        //@ts-ignore
				if (currentPage !== -1 && currentPage !== page) {
					makePageIndex(page);
				}
				
			},	
			
			onAfterSort:function(evtParam){
				var sheet = evtParam.sheet;
				
				sheet.goToPageByIndex(1);
				if(sheet.getShownRows().length != 0){
					sheet.focus(sheet.getShownRows()[0], "SEQ");
				}
			},

		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
		
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'Main_sheet', // 생성할 시트의 id
				el: 'ap_trade_detail', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: SheetData // 생성될 시트의 정적데이터
				
			});
			
			//@ts-ignore
			window.currentPage = -1;
		},

		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.Main_sheet.down2Excel({fileName: "이상거래감지_"+today+".xlsx", SheetDesign:3, excelRowHeight:16.5, excelFontSize:10, downCols: "Visible"});
			
		},

	}

    async function onClickSearch() {
		const response:any = await CommonUtil.execute({
            url:"adm_6810_r001",
            data: {
				"REG_YYYY" : REG_YYYY,
				"PAY_REQ_NO" : PAY_REQ_NO,
			}
        })
    	.then((response: any) => {
			totalCnt.current = Object.keys(response.REC).length;
			setTotalRowCnt(totalCnt.current);
			
			SheetData = response.REC;
			// @ts-ignore
	        Main_sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	        // @ts-ignore
	        Main_sheet.loadSearchData(SheetData);	
			// @ts-ignore
			makePageIndex(Main_sheet.getPageIndex( Main_sheet.getFocusedPage()) + 1); // 페이지 초기화   			
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
    	});	        
     	
    };    

	const makePageIndex = function (tp:number) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}
	
			// @ts-ignore
			if (document.getElementById('pageNavi').firstChild) {
				// @ts-ignore
				document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
			}
	
			// @ts-ignore
			currentPage = tp;
			// @ts-ignore
			let sr = totalCnt.current // 전체 조회 건수
			// @ts-ignore
			let page = rowCnt.current; // 페이지당 레코드 수
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			ul.style.textAlign = 'center';
	
			let k = 1;
	
			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				addEventHandler(li, 'click', pageMove, 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
				
				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, tp - 1);
				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}
	
			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					addEventHandler(li, 'click', pageMove, i);
					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}
	
			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";	
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');
				addEventHandler(li, 'click', pageMove, tp + 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
				
				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}
	
			ul.className = 'pg';
			// @ts-ignore
			document.getElementById('pageNavi').appendChild(ul);
		} catch (ex) {
			// @ts-ignore
			console.log(ex.message);
		}
	}
	
	const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}
	
	const pageMove = function (cPage:number) {
		// @ts-ignore
		Main_sheet.goToPageByIndex(cPage);
	}    
    
	const handleSelect = (e) => {
		if(e.target.name === 'showRowCnt'){
			setShowRowCnt(e.target.value);
			rowCnt.current = e.target.value;
		   	// @ts-ignore
		   	IBSheet.disposeAll(true);		  
		   	ib.init.Cfg.PageLength = e.target.value;
		   	ib.create();
		   
		}
	};
		
	const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setFDS_CFG_YN(event.target.value);
	};
	
	
	const hoursData = Array.from({ length: 24 }, (_, i) => ({
		code: i.toString().padStart(2, '0'),
		name: i.toString().padStart(2, '0'),
	}));
  	
	const minutes = Array.from({ length: 60 }, (_, i) => ({
		code: i.toString().padStart(2, '0'),
		name: i.toString().padStart(2, '0'),
	}));
  	
	async function onClose() {
	  setModalIsOpen(false);
		
	};  	

    async function onAfterOpen() {
		const response:any = await CommonUtil.execute({
            url:"adm_6810_r002",
            data: {
			}
        })
    	.then((response: any) => {
			setFDS_CFG_YN(response.FDS_CFG_YN);
			setFDS_START_HH(response.FDS_START_HH);
			setFDS_START_MI(response.FDS_START_MI);
			setFDS_END_HH(response.FDS_END_HH);
			setFDS_END_MI(response.FDS_END_MI);
			
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
    	});	   	
    	
	};
	
    async function onClickSave(event) {
		if (FDS_START_HH === '' || FDS_START_MI === '' || FDS_END_HH === '' || FDS_END_MI === '') {
			UIUtils.alert('집행통제시간 입력해주세요.').then();
			return;
		} 
		   	
        if(await UIUtils.confirm('저장하시겠습니까?')){		
	        const response:any = await CommonUtil.execute({
	            url:"adm_6810_u003",
	            data: {
					"FDS_CFG_YN" : FDS_CFG_YN,	
					"FDS_START_TIME" : FDS_START_HH + FDS_START_MI,
					"FDS_END_TIME": FDS_END_HH + FDS_END_MI,
				}
	        })
			.then((response: any) => {
				UIUtils.alert('정상처리되었습니다.').then();
	            // @ts-ignore
	            onClose();
			}).catch((error) => {
		    	CommonUtil.showAxiosError(error);
		    	return;
	       	});	  
	       	
		}
		
    };    	

	const activeEnter = (e) => {
		if(e.key === "Enter") {
			onClickSearch();
		}
	}
	  	
	React.useEffect(() => {
        // @ts-egnore
		ib.create();

        return () => {
          // @ts-ignore
          IBSheet.disposeAll(true);
		}
		
    },[])
    		
	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">
					<ul className="fww-brd">
						<li><Link to="/admin/">홈</Link></li>
						<li><Link to="#">관리자페이지</Link></li>
						<li><Link to="#">시스템관리</Link></li>
						<li><Link to="#">이상거래감지</Link></li>
					</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">이상거래감지</h1>
					
					<form className="sf sf-1row sf-3col">
						<div className="inner">
							<div className="sf-item">
								<p className="sf-key">집행기간</p>
								<div className="sf-value">
									<div className="sl sl-md w100p">
										<UISelect
								        	className=""
								        	firstName={"all"}
								        	value={REG_YYYY}
								        	valueChanged={(value) => setREG_YYYY(value)}
								        	codeData={[
												{ code: '2024', name: '2024' },
												{ code: '2025', name: '2025' },
												{ code: '2026', name: '2026' },
												{ code: '2027', name: '2027' },
												{ code: '2028', name: '2028' },
												{ code: '2029', name: '2029' },
												{ code: '2030', name: '2030' },
												{ code: '2031', name: '2031' },
												{ code: '2032', name: '2032' },
												{ code: '2033', name: '2033' },
											]}
								      	/>											
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">지급신청번호</p>
								<div className="sf-value">
									<UIInput className={'tf tf-md w100p'} value={PAY_REQ_NO} placeholder={''} valueChanged={(value) => setPAY_REQ_NO(value)} onKeyEnter={(e) => activeEnter(e)}/>
								</div>
							</div>
						</div>
						<button className="bt" data-color="pri" data-size="md"  type="button"  onClick={onClickSearch}>조회</button>
					</form>

					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
						</div>
						<div className="hz-root hz-gap5">
							<Button color="pri-o" size="sm" onClick={() => setModalIsOpen(true)}>이상거래감지 설정</Button>	
							<Button color="gray-o" size="sm" onClick={()=> ib.exportData()}>다운로드</Button>	
							<div className="sl sl-sm w120">
								<select name="showRowCnt" id="showRowCnt" className="" value={showRowCnt}  onChange={(handleSelect)}>
									<option value="0">20개씩보기</option>
									<option value="0">50개씩보기</option>
									<option value="0">100개씩보기</option>
									<option value="0">200개씩보기</option>
									<option value="0">500개씩보기</option>
									<option value="0">1000개씩보기</option>
								</select>
							</div>									
						</div>
					</div>
					<div className="ibsheet" id='ap_trade_detail'></div>
					<div id="pageNavi" className="pg"></div>
				</main>
				</div>

		{/* modal - 6811p*/}
		<ModalPopup
				//open={modaladm6811p.isShowing}
				open={modalIsOpen}
				title="이상거래감지 설정"
				size="mid"
				onClose={() => onClose()}
				onAfterOpen={() => onAfterOpen()}
			>
				<div className="modal-con">
					{/*클래스옵션: fo-col2, fo-col3 sf-1row*/}
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">지정시간외 통제</p>
								<div className="fo-value">
									<div className="hz-root hz-gap15">
										<label htmlFor="rd-1-1" className="ip-rd-label">
											<input name="rd-1" id="rd-1-1" className="ip-rd" value='Y' type="radio" checked={FDS_CFG_YN === 'Y'} onChange={handleOptionChange}/>
											<span className="check"></span>
											<span className="txt">사용</span>
										</label>
										<label htmlFor="rd-1-2" className="ip-rd-label">
											<input name="rd-1" id="rd-1-2" className="ip-rd" value='N' type="radio" checked={FDS_CFG_YN === 'N'} onChange={handleOptionChange}/>
											<span className="check"></span>
											<span className="txt">미사용</span>
										</label>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">집행통제시간</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8">
										<div className="sl sl-sm w75">
											<UISelect
									        	className=""
									        	firstName={"sel"}
									        	value={FDS_START_HH}
									        	valueChanged={(value) => setFDS_START_HH(value)}
									        	codeData={hoursData}
									      	/>										
										</div>
										<span className="hz-item">시</span>
										<div className="sl sl-sm w75">
											<UISelect
									        	className=""
									        	firstName={"sel"}
									        	value={FDS_START_MI}
									        	valueChanged={(value) => setFDS_START_MI(value)}
									        	codeData={minutes}
									      	/>
										</div>
										<span className="hz-item">분</span>
										<span className="hz-item"> ~ </span>
										<div className="sl sl-sm w75">
											<UISelect
									        	className=""
									        	firstName={"sel"}
									        	value={FDS_END_HH}
									        	valueChanged={(value) => setFDS_END_HH(value)}
									        	codeData={hoursData}
									      	/>
										</div>
										<span className="hz-item">시</span>
										<div className="sl sl-sm w75">
											<UISelect
									        	className=""
									        	firstName={"sel"}
									        	value={FDS_END_MI}
									        	valueChanged={(value) => setFDS_END_MI(value)}
									        	codeData={minutes}
									      	/>
										</div>
										<span className="hz-item">분</span>
									</div>
								</div>
							</div>
						</div>
					</form>
					<p className="tx tx-alert">통제시간내에 집행이 발생한 경우 이체가 되지 않습니다.</p>
				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='gray-o' size="md" onClick={() => onClose()}>취소</Button>
						<Button color='pri' size="md" onClick={onClickSave}>저장</Button>
					</div>
				</div>	
			</ModalPopup>

		</PageContainer>
	);
}
export default ContentsContainer;